import styled, { keyframes } from 'styled-components';

import { COLORS, REDUCED_MOTION, SECURE_BRAND, SECURE_BRAND_ANIM } from '../../../../theme/tokens';

/** The picture fills its well's height, centred, and keeps its proportions (the well clips its sides). */
export const Picture = styled.svg`
  display: block;
  flex: 0 0 auto;
  height: 100%;
  width: auto;
  aspect-ratio: 240 / 148;
  overflow: visible;
`;

/** The two sheets, lifted off the well together. */
export const Sheets = styled.g`
  filter: ${SECURE_BRAND.paperShadow};
`;

/** The seal comes down from above, a little turned, presses in past its size and settles. */
const stamp = keyframes`
  0% {
    opacity: 0;
    transform: scale(1.7) rotate(-16deg);
    animation-timing-function: ${SECURE_BRAND_ANIM.EASE_FALL};
  }
  55% {
    opacity: 1;
    transform: scale(0.93) rotate(2deg);
    animation-timing-function: ${SECURE_BRAND_ANIM.EASE};
  }
  100% {
    opacity: 1;
    transform: none;
  }
`;

/** The ring the stamp sends out: from the seal's edge outward, fading. */
const spread = keyframes`
  from {
    opacity: 0.8;
    transform: scale(1);
  }
  to {
    opacity: 0;
    transform: scale(1.9);
  }
`;

/** The seal, centred on its own box so it turns and scales about its middle. */
export const Seal = styled.g<{ $delayMs: number }>`
  transform-box: fill-box;
  transform-origin: center;
  animation: ${stamp} ${SECURE_BRAND_ANIM.SEAL_MS}ms both;
  animation-delay: ${(p) => p.$delayMs}ms;

  ${REDUCED_MOTION} {
    animation: none;
  }
`;

/** Hidden but for its one spread, which starts as the stamp lands. */
export const Ring = styled.circle<{ $delayMs: number }>`
  fill: none;
  stroke: ${COLORS.ctaSolid};
  stroke-width: 2;
  opacity: 0;
  transform-box: fill-box;
  transform-origin: center;
  animation: ${spread} ${SECURE_BRAND_ANIM.SEAL_RING_MS}ms ${SECURE_BRAND_ANIM.EASE};
  animation-delay: ${(p) => p.$delayMs + SECURE_BRAND_ANIM.SEAL_MS * 0.5}ms;

  ${REDUCED_MOTION} {
    animation: none;
  }
`;

/** The seal's disc, in the brand orange (the primary button's fill). */
export const SealDisc = styled.circle`
  fill: ${COLORS.ctaSolid};
`;

/** The dashed groove inside the disc's rim. */
export const SealGroove = styled.circle`
  fill: none;
  stroke: ${COLORS.onAccent};
  stroke-opacity: 0.45;
  stroke-width: 1;
  stroke-dasharray: 2 2.2;
`;

/** The shield and its check, in the ink the primary button writes on orange. */
export const SealGlyph = styled.path`
  fill: none;
  stroke: ${COLORS.ctaSolidText};
  stroke-width: 1.7;
  stroke-linecap: round;
  stroke-linejoin: round;
`;
